import clsx from 'clsx';
import React from 'react';
import styles from './ReportAccordion.module.scss';
import { Collapse } from 'tt-ui-lib/core';
import { UpIcon, DownIcon } from 'tt-ui-lib/icons';

const ReportAccordion = ({ data, renderAnswer, panelStyle }) => {
  const getIcon = ({ isActive }) =>
    isActive ? (
      <UpIcon style={{ width: '20px', height: '20px' }} />
    ) : (
      <DownIcon style={{ width: '20px', height: '20px' }} />
    );

  const getItems = (items, isTopLevel = false) =>
    items.map((item) => {
      // Разделение детей на ссылки и панели
      const childrenWithPanels = item.children?.filter((child) => child.children) || [];
      const childrenWithAnswer = item.children?.filter((child) => child.answer) || [];

      const hasPanels = childrenWithPanels.length > 0;
      const hasAnswer = childrenWithAnswer.length > 0;

      return {
        key: item.key,
        label: <span className={styles.collapseText}>{item.label}</span>,
        children: (
          <div className={styles.childrenContainer}>
            {/* Сначала рендерим вложенные панели */}
            {hasPanels && (
              <Collapse
                items={getItems(childrenWithPanels)}
                className={styles.nestedCollapse}
                bordered={false}
                expandIcon={getIcon}
              />
            )}
            {/* Затем добавляем ссылки */}
            {hasAnswer && (
              <div className={styles.answerListContainer}>
                {childrenWithAnswer.map((answer) => renderAnswer(answer))}
              </div>
            )}
          </div>
        ),
        className: clsx(styles.panelStyle, isTopLevel && styles.topLevel),
      };
    });

  return <Collapse items={getItems(data, true)} bordered={false} expandIcon={getIcon} />;
};

export default ReportAccordion;
